import moment from "moment";
import "moment/locale/es";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";
import { BloqueFirmasPdf } from "../Components/PdfComponents/BloqueFirmasPdf";

moment.locale("es");

const layoutTabla = {
  hLineWidth: () => 1,
  vLineWidth: () => 1,
  hLineColor: () => "#adaaaa",
  vLineColor: () => "#adaaaa",
};

const layoutRecuadro = {
  hLineWidth: () => 1,
  vLineWidth: () => 1,
  hLineColor: () => "#adaaaa",
  vLineColor: () => "#adaaaa",
  hLineStyle: (i, node) => (i === 0 || i === node.table.body.length ? null : { dash: { length: 2, space: 1 } }),
  vLineStyle: (i, node) => (i === 0 || i === node.table.widths.length ? null : { dash: { length: 2 } }),
};

const texto = (valor) => (valor === undefined || valor === null || valor === "" ? "-" : String(valor));

const fecha = (valor) => (valor ? moment(valor).locale("es").format("LL") : "-");

const fechaHora = (valor) => (valor ? moment(valor).locale("es").format("LL HH:mm") : "-");

const tiempo = (minutos) => {
  const valor = Number(minutos) || 0;
  if (!valor) return "-";
  return valor >= 60 ? `${Math.round((valor / 60) * 100) / 100} h` : `${Math.round(valor * 100) / 100} min`;
};

const encabezado = (titulo, alignment = "center") => ({ text: titulo, style: "tituloTabla", alignment });

const celda = (valor, alignment = "left", extra = {}) => ({ text: texto(valor), style: "textoTabla", alignment, ...extra });

const datoEtiqueta = (etiqueta, valor) => [
  { text: etiqueta, style: "subheader" },
  { text: texto(valor), style: "textoChico" },
];

const tituloSeccion = (titulo) => ({ text: titulo, style: "tableHeaderIzquierda", margin: [0, 10, 0, 5] });

const tabla = (widths, cabecera, filas) => ({
  style: "tablaSinMargen",
  table: { headerRows: 1, dontBreakRows: true, widths, body: [cabecera, ...filas] },
  layout: layoutTabla,
});

const ordenMaquilaPdf = (values) => {
  const empresa = values?.empresa || {};
  const orden = values?.orden || {};
  const preCotizacion = values?.preCotizacion || null;
  const materiales = values?.materiales || [];
  const insumos = values?.insumos || [];
  const mostrarRegimen = !empresa?.deshabilitarRegimenFiscal;
  const tieneLogo = !!empresa?.logo?.base64Completa;
  const matriz = (orden.matrices || [])[0] || {};
  const suministra = preCotizacion
    ? [preCotizacion.materialPropio && "La empresa", preCotizacion.materialPorCliente && "El cliente"].filter(Boolean).join(" y ")
    : "";
  const entrega = { recoleccion: "Recolección (cliente)", entrega: "Entrega (chofer)" }[preCotizacion?.recoleccionOEntrega];

  const cabecera = HeaderEmpresaCard(empresa, mostrarRegimen, false, {
    border: [false, false, false, false],
    table: {
      headerRows: 1,
      widths: ["100%"],
      body: [
        [{ text: "N° Orden:", style: "subheader", alignment: "center" }],
        [{ text: texto(orden.folio), style: "textoChico", alignment: "center" }],
        [{ text: "Inicio:", style: "subheader", alignment: "center" }],
        [{ text: fechaHora(orden.fechaInicio), style: "textoChico", alignment: "center" }],
        [{ text: "Fin estimado:", style: "subheader", alignment: "center" }],
        [{ text: fechaHora(orden.fechaFinEstimada), style: "textoChico", alignment: "center" }],
        ...(preCotizacion?.urgente ? [[{ text: "URGENTE", style: "subheader", color: "#c0392b", alignment: "center" }]] : []),
      ],
    },
    layout: "noBorders",
  });
  if (!tieneLogo) cabecera[0] = { border: [false, false, false, false], text: "" };

  const dd = {
    content: [
      {
        style: "tableExample",
        table: { widths: ["20%", "50%", "30%"], layout: "noBorders", body: [cabecera] },
      },
      { text: "Orden de Maquila N° " + texto(orden.folio), style: "tableHeaderIzquierda" },
      {
        style: "tableExample",
        table: {
          widths: ["50%", "50%"],
          body: [
            [
              {
                table: {
                  widths: ["35%", "65%"],
                  body: [
                    datoEtiqueta("Pieza:", [matriz.clave, matriz.descripcion].filter(Boolean).join(" - ")),
                    datoEtiqueta("Cantidad:", `${texto(orden.cantidadEsperada)} ${matriz.unidad || ""}`.trim()),
                    datoEtiqueta("Tiempo estimado:", tiempo(orden.duracionEstimadaMin)),
                    datoEtiqueta("Cliente:", preCotizacion?.cliente),
                    datoEtiqueta("Contacto:", preCotizacion?.contacto),
                    datoEtiqueta("Pre cotización:", preCotizacion ? [preCotizacion.folio, preCotizacion.nombre].filter(Boolean).join(" · ") : ""),
                  ],
                },
                layout: "noBorders",
              },
              {
                table: {
                  widths: ["35%", "65%"],
                  body: [
                    datoEtiqueta("Encargado:", preCotizacion?.encargado),
                    datoEtiqueta("Proyecto:", orden.proyecto),
                    datoEtiqueta("Fecha compromiso:", fecha(preCotizacion?.fechaCompromiso)),
                    datoEtiqueta("Programación de entrega:", entrega),
                    datoEtiqueta("Suministra material:", suministra),
                  ],
                },
                layout: "noBorders",
              },
            ],
          ],
        },
        layout: layoutRecuadro,
      },
      ...(materiales.length
        ? [
            tituloSeccion("Material"),
            tabla(
              ["5%", "35%", "16%", "24%", "20%"],
              [encabezado("#"), encabezado("Material"), encabezado("Cantidad"), encabezado("Procesos"), encabezado("Características")],
              materiales.map((m, indice) => [
                celda(indice + 1, "center"),
                celda([m.clave, m.descripcion].filter(Boolean).join(" - "), "left", { bold: true }),
                celda(`${m.cantidad} ${m.unidad || ""}`.trim(), "right"),
                celda(m.procesos),
                celda(m.caracteristicas),
              ])
            ),
          ]
        : []),
      ...(insumos.length
        ? [
            tituloSeccion("Insumos de la orden"),
            tabla(
              ["18%", "44%", "12%", "13%", "13%"],
              [encabezado("Clave"), encabezado("Insumo"), encabezado("Unidad"), encabezado("Por pieza"), encabezado("Total")],
              insumos.map((i) => [celda(i.clave), celda(i.descripcion), celda(i.unidad, "center"), celda(i.porPieza, "right"), celda(i.total, "right")])
            ),
          ]
        : []),
      ...((orden.etapas || []).length
        ? [
            tituloSeccion("Avance"),
            tabla(
              ["70%", "30%"],
              [encabezado("Etapa"), encabezado("Piezas")],
              orden.etapas.map((e) => [celda(e.nombre), celda(e.piezas, "right")])
            ),
          ]
        : []),
      ...(preCotizacion?.notas
        ? [tituloSeccion("Notas"), tabla(["100%"], [encabezado("Para la orden de maquila")], [[celda(preCotizacion.notas)]])]
        : []),
      BloqueFirmasPdf([{ titulo: "Elaboró", nombre: orden.elaboro || "" }, { titulo: "Recibió producción", nombre: "" }]),
    ],
    images: tieneLogo ? { logo: empresa.logo.base64Completa } : {},
    styles: {
      header: { fontSize: 9, bold: true },
      subheader: { fontSize: 8, bold: true },
      tableExample: { margin: [0, 5, 0, 5] },
      tablaSinMargen: { margin: [0, 0, 0, 0] },
      tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
      tableHeader: { bold: true, fontSize: 12, color: "black", alignment: "center" },
      textoChico: { fontSize: 8 },
      tituloTabla: { fontSize: 8, bold: true, fillColor: "#cccccc", alignment: "center" },
      textoTabla: { fontSize: 8, italics: false },
    },
    pageSize: "LETTER",
  };

  if (orden.estado === 2) {
    dd.watermark = { text: "CANCELADA", color: "GRAY", opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 110 };
  }

  return dd;
};

export default ordenMaquilaPdf;
